module.exports = __webpack_public_path__ + "img/er1.a475cc20.png";